import { IGetStudentPaginatedRosterData } from '../../../../apollo/types';

/**
 * Merges allStudentData with updated statuses from paginatedStudentTestStatus.
 * Returns a new array of students with updated dapTestStatus for matching IDs.
 *
 * @param allStudentData - Array of students from the roster query
 * @param paginatedStudentTestStatus - Array of students with updated statuses
 */
export function mergeStudentStatuses(
  allStudentData: IGetStudentPaginatedRosterData[],
  // eslint-disable-next-line
  paginatedStudentTestStatus: { id: string; dapTestStatus: any }[]
  // eslint-disable-next-line
): any[] {
  const statusMap = new Map(
    // eslint-disable-next-line
    paginatedStudentTestStatus.map((student: any) => [
      student.id,
      {
        dapTestStatus: student?.dapTestStatus,
        room: student?.room,
        absent: student?.absent,
        deniedEntry: student?.deniedEntry,
        examStartTime: student?.examStartTime,
        estimatedExamEndTime: student?.estimatedExamEndTime,
      },
    ])
  );

  // eslint-disable-next-line
  return allStudentData.map((student: any) => {
    if (statusMap.has(student.id)) {
      return {
        ...student,
        dapTestStatus: statusMap.get(student.id)?.dapTestStatus,
        room: statusMap.get(student.id)?.room,
        absent: statusMap.get(student.id)?.absent,
        deniedEntry: statusMap.get(student.id)?.deniedEntry,
        examStartTime: statusMap.get(student.id)?.examStartTime ?? student.examStartTime,
        estimatedExamEndTime: statusMap.get(student.id)?.estimatedExamEndTime ?? student.estimatedExamEndTime,
      };
    }
    return student;
  });
}
